/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Calendar } from 'react-calendar';
import S3 from 'react-aws-s3';
import { Bannerconfig } from '../../redux/helper/upload-config';
import ThreeDotsLoader from '../../Components/LoadingDots';
import { GenerateDateandTime, GenerateDate, GenerateDateFormat } from '../../redux/helper/DateConverter';

function AddBannerModal({
    addBannerModal, setAddbannerModal, bannerselected, setbannerselected, bannerDetails, setBannerDetails, handleUploadBanner, setIsEditState, isEditState, selectedBannner, setErrorIndication, errorIndication, threeDotLoader, setThreeDotsLoader,
}) {
    const dateRef = useRef();
    if (isEditState) {
        useEffect(() => {
            setBannerDetails((prevState) => ({
                ...prevState,
                title: selectedBannner.title,
                description: selectedBannner.description,
                start_date: GenerateDateandTime((selectedBannner.start_date)),
                end_date: GenerateDateandTime((selectedBannner.end_date)),
                link: selectedBannner.link,
                desktop_url: selectedBannner.desktop_url,
                mobile_url: selectedBannner.mobile_url,
                tab_url: selectedBannner.tab_url,
            }));
        }, [isEditState]);
    }
    const ReactS3Client = new S3(Bannerconfig);
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);
    const [bannerimages, setBannerImages] = useState({
        desktop_url: '',
        mobile_url: '',
        tab_url: '',
    });
    const [updateState, setupdateState] = useState(false);

    const InputChange = (e, index) => {
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setBannerDetails((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setBannerDetails((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const convertToDate = (dateString) => {
        if (!dateString || dateString.trim() === '') return null;
        const ddmmyyyyMatch = dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (ddmmyyyyMatch) {
            const day = parseInt(ddmmyyyyMatch[1], 10);
            const month = parseInt(ddmmyyyyMatch[2], 10) - 1;
            const year = parseInt(ddmmyyyyMatch[3], 10);
            const date = new Date(year, month, day);
            return Number.isNaN(date.getTime()) ? null : date;
        }
        const date = new Date(dateString);
        return Number.isNaN(date.getTime()) ? null : date;
    };

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setBannerDetails((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state);
        // setbannerselected((prevState) => ({
        //     ...prevState,
        //     [key]: val,
        // }));
        setBannerDetails((prevState) => ({
            ...prevState,
            [key]: (val),
        }));
        settoggle(toggleState);
    };

    const handleUploadedFiles = (val, key, s3key) => {
        const dataCopy = { ...bannerDetails };
        dataCopy[key] = s3key;
        setBannerDetails(dataCopy);
        const imageUrlCopy = { ...bannerimages };
        imageUrlCopy[key] = val;
        setBannerImages(imageUrlCopy);
        setupdateState(true);
    };

    const handleUploadDoc = (e, key) => {
        const files = e.target.files[0];
        ReactS3Client.uploadFile(files)
            .then((data) => {
                handleUploadedFiles(files.name, key, data.key);
            })
            .catch((err) => err);
    };

    const handleDelete = (key) => {
        const temp = { ...bannerDetails };
        if (key === 'desktop_url') {
            temp.desktop_url = '';
        }
        if (key === 'mobile_url') {
            temp.mobile_url = '';
        }
        if (key === 'tab_url') {
            temp.tab_url = '';
        }
        setBannerDetails(temp);
    };

    const handleClose = () => {
        setAddbannerModal(false);
        setIsEditState(false);
        setBannerDetails({
            title: '',
            description: '',
            start_date: '',
            end_date: '',
            link: '',
            desktop_url: '',
            mobile_url: '',
            tab_url: '',
        });
    };

    useEffect(() => {
        setupdateState(false);
    }, [updateState]);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${addBannerModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="add-Banner-modal" tabIndex="-1" aria-labelledby="exampleModalCenterTitle" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative min-w-[449px] max-w-[449px] pointer-events-none" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative py-[26px]">
                        <h5 className="text-xs4 font-semibold leading-normal text-[#090406] email" id="exampleModalScrollableLabel">
                            {isEditState ? 'Update Banner' : 'Add Banner'}
                        </h5>
                        <button
                            type="button"
                            className="absolute top-5 right-3"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => handleClose()}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative px-[46px]">
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="title"
                                data-testid="banner-title-input"
                                className="h-12 w-full rounded-lg outline-0 error2 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3"
                                autoComplete="off"
                                value={bannerDetails.title}
                                onChange={(e) => {
                                    InputChange(e);
                                    setErrorIndication(false);
                                }}
                            />
                            <label htmlFor="title" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Title
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                            {(errorIndication && bannerDetails.title === '') && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Title is required</p>}
                        </div>
                        <div className="relative w-full mt-6">
                            <textarea
                                type="text"
                                id="description"
                                data-testid="banner-description-input"
                                className="w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal resize-none text-[#090406] px-3 py-5 h-[150px] error2"
                                autoComplete="off"
                                value={bannerDetails.description}
                                onChange={(e) => {
                                    InputChange(e);
                                    setErrorIndication(false);
                                }}
                            />
                            <label htmlFor="description" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Description
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                            <p className="absolute top-[126px] right-2 font-normal text-xs3 text-[#808285]">Max. 500 Characters</p>
                            {(errorIndication && bannerDetails.description === '') && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Description is required</p>}
                        </div>
                        <div className="relative w-full mt-7">
                            <input
                                type="text"
                                id="link"
                                data-testid="banner-link-input"
                                className="h-12 w-full rounded-lg outline-0 error2 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3"
                                autoComplete="off"
                                value={bannerDetails.link}
                                onChange={(e) => {
                                    InputChange(e);
                                    setErrorIndication(false);
                                }}
                            />
                            <label htmlFor="link" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Link
                            </label>
                            <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1 hidden">Link is required</p>
                        </div>
                        <div className="relative mt-5" ref={dateRef}>
                            <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                <div
                                    className="relative sm:w-1/2 w-full px-1 mb-2"
                                    data-testid="banner-start-date-container"
                                    onClick={() => { handleToggle('start_date'); setErrorIndication(false); }}
                                >
                                    <label className="absolute -top-2 left-3.5 px-1 bg-[#FFFFFF] font-semibold text-[#808285] text-xs2">
                                        Start Date
                                        {' '}
                                        <span className="text-[#ED1C24]">*</span>
                                    </label>
                                    <img
                                        src="images/Iconawesome-calendar-alt.svg"
                                        alt="icon"
                                        className="absolute top-3 right-2.5 cursor-pointer"
                                        onClick={() => handleToggle('start_date')}
                                    />
                                    <input
                                        datepicker
                                        datepicker-autohide
                                        type="text"
                                        data-testid="banner-start-date-input"
                                        className="cursor-pointer h-[38px] w-full rounded-lg outline-0 error2 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"
                                        placeholder="From date"
                                        value={bannerDetails.start_date === '' ? '' : GenerateDateFormat(bannerDetails.start_date)}
                                        onChange={(e) => {
                                            const parsedDate = convertToDate(e.target.value.trim());
                                            if (parsedDate) {
                                                setBannerDetails((prevState) => ({
                                                    ...prevState,
                                                    start_date: parsedDate,
                                                    end_date: '',
                                                }));
                                            }
                                            setErrorIndication(false);
                                        }}
                                    />
                                    {(errorIndication && bannerDetails.start_date === null) && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1 hidden">Start Date is required</p>}
                                </div>
                                {toggle.start_date && (
                                    <Calendar
                                        value={moment(bannerDetails.start_date).format('YYYY/MM/DD').start_date}
                                        onChange={(val) => handleDate((val), 'start_date')}
                                        placeholder="Date from"
                                    />
                                )}
                                <div
                                    className="relative sm:w-1/2 w-full px-1 mb-2"
                                    data-testid="banner-end-date-container"
                                    onClick={() => { handleToggle('end_date'); setErrorIndication(false); }}

                                >
                                    <label className="absolute -top-2 left-3.5 px-1 bg-[#FFFFFF] font-semibold text-[#808285] text-xs2">
                                        End Date
                                        {' '}
                                        <span className="text-[#ED1C24]">*</span>
                                    </label>
                                    <img
                                        src="images/Iconawesome-calendar-alt.svg"
                                        alt="icon"
                                        className="absolute top-3 right-2.5 cursor-pointer"
                                        onClick={() => handleToggle('end_date')}

                                    />
                                    <input
                                        datepicker
                                        datepicker-autohide
                                        type="text"
                                        data-testid="banner-end-date-input"
                                        className="cursor-pointer h-[38px] w-full rounded-lg outline-0 error2 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"
                                        placeholder="To date"
                                        value={bannerDetails.end_date === '' ? '' : GenerateDateFormat(bannerDetails.end_date)}
                                        onChange={(e) => {
                                            const parsedDate = convertToDate(e.target.value.trim());
                                            if (parsedDate) {
                                                setBannerDetails((prevState) => ({
                                                    ...prevState,
                                                    end_date: parsedDate,
                                                }));
                                            }
                                            setErrorIndication(false);
                                        }}
                                    />
                                    {(errorIndication && bannerDetails.end_date === null) && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1 hidden">End Date is required</p>}
                                </div>
                                {toggle.end_date && (
                                    <Calendar
                                        value={moment(bannerDetails.end_date).format('YYYY/MM/DD').end_date}
                                        onChange={(val) => handleDate((val), 'end_date')}
                                        minDate={moment(bannerDetails.start_date).toDate()}
                                        placeholder="Date to"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="flex items-center attach-file">
                            <div className="relative mt-3 mb-1 bg-[#555259] rounded-lg pl-[14px] py-3 h-8 cursor-pointer w-[40%]">
                                <span htmlFor="file" className="font-normal text-xs13 text-white absolute left-0 top-2 pl-[14px] cursor-pointer">+ Attach image for Web*</span>
                                <input
                                    type="file"
                                    className="opacity-0 absolute top-0 left-0 cursor-pointer w-[100px]"
                                    onChange={(e) => {
                                        handleUploadDoc(e, 'desktop_url');
                                        setErrorIndication(false);
                                    }}
                                    id="desktop_url"
                                    data-testid="banner-desktop-upload"
                                />
                            </div>
                            <p className="font-normal text-xs3 text-[#808285] ml-3 image-file">Max. image file size is 5 MB</p>
                            <p className="font-normal text-xs3 text-[#808285] ml-3 image-file">(1148px x 296px)</p>

                        </div>
                        {(errorIndication && bannerDetails.desktop_url === '') && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Image for Web is required</p>}
                        <p>
                            {bannerDetails.desktop_url !== ''
                            && (
                                <div className="flex align-items">
                                    <div>
                                        {bannerDetails.desktop_url}
                                        <img
                                            src="/images/circle-close.svg"
                                            alt="icon"
                                            data-testid="banner-desktop-uploaded"
                                            className="pr-4 cursor-pointer"
                                            onClick={() => handleDelete('desktop_url')}
                                        />
                                    </div>

                                </div>
                            )}

                        </p>
                        <div className="flex items-center attach-file">
                            <div className="relative mt-3 mb-1 bg-[#555259] rounded-lg pl-[14px] py-3 h-8 cursor-pointer w-[40%]">
                                <span htmlFor="file" className="font-normal text-xs13 text-white absolute left-0 top-2 pl-[14px] cursor-pointer">+ Attach image for Tab*</span>
                                <input
                                    type="file"
                                    className="opacity-0 absolute top-0 left-0 cursor-pointer w-[100px]"
                                    onChange={(e) => {
                                        handleUploadDoc(e, 'tab_url');
                                        // setErrorIndication(false);
                                    }}
                                    id="tab_url"
                                    data-testid="banner-tab-upload"
                                />
                            </div>
                            <p className="font-normal text-xs3 text-[#808285] ml-3 image-file">Max. image file size is 5 MB</p>
                            <p className="font-normal text-xs3 text-[#808285] ml-3 image-file">(800px x 250px)</p>

                        </div>
                        {(errorIndication && bannerDetails.tab_url === '') && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Image for Tab is required</p>}
                        <p>
                            {bannerDetails.tab_url !== ''
                            && (
                                <div className="flex align-items">
                                    <div>
                                        {bannerDetails.tab_url}
                                        <img
                                            src="/images/circle-close.svg"
                                            alt="icon"
                                            data-testid="banner-tab-uploaded"
                                            className="pr-4 cursor-pointer"
                                            onClick={() => handleDelete('tab_url')}
                                        />
                                    </div>

                                </div>
                            )}
                        </p>
                        <div className="flex items-center attach-file">
                            <div className="relative mt-3 mb-1 bg-[#555259] rounded-lg pl-[14px] py-3 h-8 cursor-pointer w-[40%]">
                                <span htmlFor="file" className="font-normal text-xs13 text-white absolute left-0 top-2 pl-[14px] cursor-pointer">+ Attach image for Mobile*</span>
                                <input
                                    type="file"
                                    className="opacity-0 absolute top-0 left-0 cursor-pointer w-[100px]"
                                    onChange={(e) => {
                                        handleUploadDoc(e, 'mobile_url');
                                        // setErrorIndication(false);
                                    }}
                                    id="mobile_url"
                                    data-testid="banner-mobile-upload"
                                />
                            </div>
                            <p className="font-normal text-xs3 text-[#808285] ml-3 image-file">Max. image file size is 5 MB</p>
                            <p className="font-normal text-xs3 text-[#808285] ml-3 image-file">(350px x 110px)</p>

                        </div>
                        {(errorIndication && bannerDetails.mobile_url === '') && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Image for Mobile is required</p>}
                        <p>
                            {bannerDetails.mobile_url !== ''
                            && (
                                <div className="flex align-items">
                                    <div>
                                        {bannerDetails.mobile_url}
                                        <img
                                            src="/images/circle-close.svg"
                                            alt="icon"
                                            data-testid="banner-mobile-uploaded"
                                            className="pr-4 cursor-pointer"
                                            onClick={() => handleDelete('mobile_url')}
                                        />
                                    </div>

                                </div>
                            )}
                        </p>

                        {/* <div className="flex items-center banner-image hidden">
                            <img src="/images/Banner.svg" alt="icon" />
                            <p className="font-semibold text-sm text-black mx-2">bannerimg.jpg</p>
                            <img src="/images/ri_close-circle-line.svg" alt="icon" className="cursor-pointer" />
                        </div> */}
                        <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1 hidden">Attach an image</p>
                    </div>
                    <div className="flex justify-center my-[22px]">
                        <button
                            type="button"
                            className="rounded-lg font-normal text-sm text-white bg-[#555259] w-[242px] py-3 outline-0 Add-Banner"
                            data-testid="add-banner-btn"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => handleUploadBanner()}
                        >
                            {threeDotLoader ? <div className="ml-[105px]"><ThreeDotsLoader /></div> : (isEditState ? 'Update Banner' : 'Add Banner')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddBannerModal;
